/** @module csi/table/matrix/_RootMap */
define([
	"dojo/_base/declare",
	"./Path"
], function(declare, PathMatrix) {

	return declare(PathMatrix, {
		bRelativeToRoot: true,
		restrictQuery: true,

		/**
		 * @override
		 * Matrix operates on attribute on root node of view, so no need to calculate nodes along a path;
		 * don't return root node here though or else _getSpecIndices won't work - just return existing row node
		 */
		_getRowNodes: function(ctx, qr, c, node) {
			return [node];
		},

		/**
		 * @override
		 * Matrix operates relative to root node
		 */
		_getSpecNodes: function(ctx, spec, nodes) {
			return [ctx.view.getViewNode()];
		},

		/**
		 * @override
		 * Context should be editable
		 */
		_renderCell: function(ctx, spec, nColumn, td, nodes, indices) {
			ctx.setReadOnly(false);
			this.inherited(arguments);
		}
	});
});